import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Response } from 'src/app/types/common.type';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RestApiService {
  httpClient = inject(HttpClient);

  getFileAsString(path: string) {
    return this.httpClient.get(path, { responseType: 'text' });
  }

  postFileAsString(path: string, request: any | null) {
    return this.httpClient.post(path, request, { responseType: 'text' });
  }

  post<T>(path: string, request: any | null): Observable<Response<T>> {
    return this.httpClient.post<Response<T>>(path, request);
  }

  get<T>(path: string): Observable<Response<T>> {
    return this.httpClient.get<Response<T>>(path);
  }

  put<T>(path: string, request: any | null): Observable<Response<T>> {
    return this.httpClient.put<Response<T>>(path, request);
  }

  delete<T>(path: string): Observable<Response<T>> {
    return this.httpClient.delete<Response<T>>(path);
  }
}
